import { render, staticRenderFns } from "./createWxOrderBZ.vue?vue&type=template&id=3f62f624&scoped=true"
import script from "./createWxOrderBZ.vue?vue&type=script&lang=js"
export * from "./createWxOrderBZ.vue?vue&type=script&lang=js"
import style0 from "./createWxOrderBZ.vue?vue&type=style&index=0&id=3f62f624&prod&scoped=true&lang=css"
import style1 from "./createWxOrderBZ.vue?vue&type=style&index=1&id=3f62f624&prod&lang=css"
import style2 from "./createWxOrderBZ.vue?vue&type=style&index=2&id=3f62f624&prod&scoped=true&lang=scss"
import style3 from "./createWxOrderBZ.vue?vue&type=style&index=3&id=3f62f624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62f624",
  null
  
)

export default component.exports